import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CatalogItem, LangItem } from 'src/app/services/backend.service';

export interface CatalogDialogData {
    vkorg: string;
    language: string;
    catalogs: CatalogItem[];
}

@Component({
    selector: 'app-select-catalog',
    templateUrl: './select-catalog.component.html',
    styleUrls: ['./select-catalog.component.scss'],
    standalone: false,
})
export class SelectCatalogComponent implements OnInit {
    data = inject<CatalogDialogData>(MAT_DIALOG_DATA);

    catalogs: CatalogItem[] = [];
    selectedCatalog?: CatalogItem;
    selectedLang?: LangItem;
    emptyCatalog: CatalogItem = { lang: [], name: '', vkorg: '', customErpTypes: [] };

    ngOnInit(): void {
        this.catalogs = this.data.catalogs;
        this.selectedCatalog = this.catalogs.find((c) => c.vkorg === this.data.vkorg);
        this.selectedLang = this.selectedCatalog?.lang.find((l) => l.id === this.data.language);
    }

    catalogChanged() {
        this.selectedLang = this.selectedCatalog?.lang.length === 1 ? this.selectedCatalog.lang[0] : undefined;
    }
}
